// extracted by mini-css-extract-plugin
module.exports = {"otherUserSelection":"OtherUserSelection__otherUserSelection__1MUXI","boxTitleRight":"OtherUserSelection__boxTitleRight__1RV0H"};